import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchAffiliatedBody = createAsyncThunk("fetchAffiliatedBody", (params, {dispatch}) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'affiliated-body',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchAffiliatedBody.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchAffiliatedBody.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchAffiliatedBody.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
